// The Product Catalog page's fetches (apps/server/src/productPage.mjs): the whole
// catalog, a product's hover cards, and moving products between groups.
import { authenticatedFetch } from '../auth/authClient';
import type { CatalogFamily, ProductFacets } from './productCatalog';

async function json<T>(response: Response): Promise<T> {
  const body = (await response.json().catch(() => ({}))) as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? `The server answered ${response.status}.`);
  return body;
}

export async function loadCatalog(): Promise<CatalogFamily[]> {
  return (await json<{ catalog: CatalogFamily[] }>(await authenticatedFetch('/api/products/catalog'))).catalog;
}

export async function loadFacets(id: string): Promise<ProductFacets> {
  return json<ProductFacets>(await authenticatedFetch(`/api/products/${encodeURIComponent(id)}/facets`));
}

export async function moveProducts(productIds: string[], groupId: string, beforeId: string | null): Promise<void> {
  await json(await authenticatedFetch('/api/products/move', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds, groupId, beforeId }),
  }));
}
